// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__19y4x","rowsWrapper":"style_rowsWrapper__FcvpU","rowWrapper":"style_rowWrapper__2L1JA"};